export const LANDING_COMPANIES = [
    "Sancor",
    "RUS",
    "Zurich",
    "Terrawind",
    "Federacion_Patronal",
    "Experta",
    "Rivadavia",
];

export function filterLandingCompanies(activeCompanies = []) {
    return LANDING_COMPANIES.filter((company) => activeCompanies.includes(company));
}

export function getCompaniesCarouselDuration(companyCount) {
    return companyCount <= 3 ? "9s" : "15s";
}
